module.exports = __webpack_public_path__ + "static/media/sb-logo.37b865c6.svg";